(function () {
    "use strict";
    angular.module("skillBuilderSaaS")
        .controller("LearningPathVersionStorefrontCtrl", ["$localStorage", "$stateParams", "messageService", "$scope", "learningPathVersionStorefrontResource", learningPathVersionStorefrontCtrl]);
    function learningPathVersionStorefrontCtrl($localStorage, $stateParams, messageService, $scope, learningPathVersionStorefrontResource) {
        var vm = this;
        vm.model = angular.copy($stateParams);
        vm.showErrors = false;
        vm.saving = false;
        vm.loading = true;
        vm.storefrontEnabled = $localStorage.tenantSettings.tenantFeaturesStorefrontEnabled;
        learningPathVersionStorefrontResource.get({ number: $stateParams.number, version: $stateParams.version }, function (result) {
            vm.original = angular.copy(result.isStorefrontEnabled);
            angular.extend(vm.model, result);
            $scope.$parent.vm.model = angular.copy(vm.model);
            angular.extend($scope.$parent.vm.model, result);
            $scope.$parent.vm.loading = false;
            vm.loading = false;
        });
        vm.toggleStorefrontEnabled = function () {
            if (!angular.equals(vm.original, vm.model.isStorefrontEnabled)) {
                if (vm.saving)
                    return;
                vm.saving = true;
                learningPathVersionStorefrontResource.save(vm.model, function (result) {
                    vm.original = angular.copy(result.isStorefrontEnabled);
                    vm.model = angular.extend(result, $stateParams);
                    angular.extend($scope.$parent.vm.model, result);
                    vm.saving = false;
                    if (result.isStorefrontEnabled)
                        messageService.success("learningPath.storefront.savePathVisibleInCatalog");
                    else
                        messageService.success("learningPath.storefront.savePathNotVisibleInCatalog");
                }, function (error) {
                    vm.model.isStorefrontEnabled = vm.original;
                    messageService.error(error);
                    vm.saving = false;
                });
            }
        };
    }
}());
